<template>
  <div>
    <UserBnxgnBind v-show="query.resultText" :query="query" />
    <div v-show="bindHref">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" />
      <form-entity :model="userModel" :rules="rules" class="form-edit">
        <form-field
          prop="code"
          :default-focus="false"
          :options="{ label: '暴虐:Code', readonly: true, placeholder: '暴虐新概念Code', type: 'text', required: true }"
        />
        <form-field
          prop="openId"
          :default-focus="false"
          :options="{
            label: '暴虐:OpenID',
            readonly: true,
            placeholder: '暴虐新概念OpenID',
            type: 'text',
            required: true
          }"
        />
        <form-field
          prop="userId"
          :default-focus="true"
          :options="{
            label: '暴虐:UserID',
            readonly: true,
            placeholder: '暴虐新概念UserID',
            type: 'text',
            required: true
          }"
        />
        <form-field
          prop="mobileNumber"
          :options="{
            label: '手机号码',
            readonly: true,
            placeholder: '手机号码',
            type: 'tel',
            format: 'phone',
            required: true
          }"
        />
        <form-field
          prop="bindHref"
          :options="{ label: '绑定地址', readonly: true, placeholder: '绑定地址', type: 'text', required: true }"
        />
        <div class="action-btns">
          <mt-button v-if="bindHref" @click="doBindHref">登录并领取权益</mt-button>
          <mt-button v-if="bindResult.havePrivilege === -1" @click="toLogin">获取公众号授权</mt-button>
        </div>
      </form-entity>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { appUser, pageArgs } from '@/utils'
import { bindUserMixin } from './options'
import UserBnxgnBind from './user_bnxgn_bind'

// 暴虐新概念的公众号下，获取用户信息
const localhost = location.host.indexOf('localhost') >= 0
const hrefIsBnxgn = location.href.indexOf('wx.bnxgn.com') >= 0
export default {
  name: 'user_bnxgn_get',
  components: {
    UserBnxgnBind
  },
  mixins: [bindUserMixin],
  data() {
    return {
      title: '暴虐新概念',
      rules: {},
      bindHref: '',
      query: {}
    }
  },
  async created() {},
  async activated() {
    // 本地的code
    const code = appUser.wxcode || appUser.code || this.user.code
    const time = appUser.wxcode ? 3000 : 0
    console.log('[bindUser] code: ', this.user.code)
    console.log('[bindUser] wxcode: ', appUser.wxcode)
    // 微信登录时延迟绑定
    setTimeout(() => {
      this.bindUser({ code })
    }, time)
  },
  computed: {
    ...mapGetters('user/login', [
      'user' // 取 appUser 或者 getWXUser
    ]),
    userModel() {
      const { user } = this
      user.bindResult = JSON.stringify(this.bindResult)
      user.bindHref = this.bindHref
      return user
    }
  },

  methods: {
    doBindHref(bindHref) {
      location.href = bindHref || this.bindHref
    },
    async bindUser(data) {
      const { bindResult } = this
      if (!data.code) {
        return this.user_bnxgn_bind({ resultText: '暴虐新概念公众号授权中' })
      }
      // 1. 用户是否有新概念课程权益
      await this.do$checkUserCoursePrivilege(data, bindResult)
      if (bindResult.havePrivilege !== true) {
        if (bindResult.codeIsError && hrefIsBnxgn) {
          this.toLogin()
        }
        return this.user_bnxgn_bind({
          resultText: bindResult.resultText,
          userId: bindResult.userId,
          nickName: bindResult.nickName
        })
      }
      // 2. 新概念是否有匹配的友邻少年ID（有权益时查询并绑定）
      await this.do$isMatchYlyk(data, bindResult)
      // bindResult.match = true // test
      if (bindResult.match) {
        // 2.1 对应友邻少年ID是否有相应权益
        await this.do$ylykIsHavePirvilege(data, bindResult)
        // bindResult.ylykIsHavePirvilege = false
        const query = {
          resultText: '正在迁移概念课程权益',
          resultSuccess: true
        }
        // 2.11 添加新概念权益
        if (!bindResult.ylykIsHavePirvilege) {
          await this.do$addPrivilege(data, bindResult)
        }
        query.resultText = bindResult.resultText
        query.resultSuccess = bindResult.resultSuccess
        query.resultObject = bindResult.resultObject
        query.userId = bindResult.userId
        query.nickName = bindResult.nickName
        if (bindResult.ylykUserStatus === -11) {
          return this.ylyk_user_bnxgn_bind(data)
        }
        return this.user_bnxgn_bind(query)
      } else {
        // 2.2 绑定手机号后添加新概念权益（跳转到友邻）
        // await this.do$bindAndAddPrivilege(data, bindResult)
        return this.ylyk_user_bnxgn_bind(data)
      }
    },
    ylyk_user_bnxgn_bind({ code }) {
      let host = 'new-wx.ylyk.com/ylyk'
      let params = ''

      const args = pageArgs.args()
      const { showConsole } = args
      if (localhost) {
        host = 'localhost:9547'
      }
      if (hrefIsBnxgn) {
        const urlport = args.port['default']
        let port = ''
        if (urlport === 'bnxgn_test') port = '/test'
        if (urlport === 'bnxgn_pre') port = '/pre'
        host = `new-wx.ylyk.com${port}/ylyk`
      }
      params = `?bnxgn_code=${code}`
      if (showConsole) params += `&showConsole=${showConsole}&time=2021`
      // 跳转迁移权限页面
      const bindHref = `https://${host}/${params}#/user_bnxgn_bind`
      if (showConsole === 'bindHref') {
        this.bindHref = bindHref
      } else {
        this.doBindHref(bindHref)
      }
    },
    // 切换到 bind 试图
    user_bnxgn_bind(query) {
      this.query = query
      console.log('user_bnxgn_bind', query)
    },
    toLogin() {
      setTimeout(() => {
        appUser.resetToken()
        location.reload()
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.action-btns {
  .mint-button {
    margin: 0 10px;
  }
}
</style>
